module.exports = __webpack_public_path__ + "img/LV40103200513.1eb7f4d3.png";